import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import AuthGate from './auth/AuthGate.jsx';
import Worklist from './pages/Worklist.jsx';
import Viewer from './pages/Viewer.jsx';
import Timeline from './pages/Timeline.jsx';
import NotForDiagnosticBanner from './components/NotForDiagnosticBanner.jsx';
import styles from './App.module.css';

export default function App() {
  return (
    <div className={styles.shell}>
      <NotForDiagnosticBanner />
      <main className={styles.main}>
        <AuthGate>
          <Routes>
            <Route path="/"                        element={<Worklist />} />
            <Route path="/study/:uid"              element={<Viewer />} />
            <Route path="/patient/:patientId"      element={<Timeline />} />
            <Route path="*"                        element={<Navigate to="/" replace />} />
          </Routes>
        </AuthGate>
      </main>
    </div>
  );
}
